<template>
  <Modal class="banknumBg" class-name="t20" v-model="trialModal" @on-cancel="hide" :mask-closable="false" :footer-hide="true" width="578">
    <!--重写顶部-->
    <p slot="header" class="ivu-modal-header-content">行号查询</p>

    <div class="banknum">
      <div class="banknum-body">
        <ul class="banknum-body-tab">
          <li :class="{'active': type === 'bank'}" @click="changeType('bank')">
            <svg-icon class="f19" icon-class="icon_t"></svg-icon>名称查询行号
          </li>
          <li :class="{'active': type === 'num'}" @click="changeType('num')">
            <svg-icon class="f19" icon-class="icon_s"></svg-icon>行号查行名
          </li>
        </ul>

        <Form class="banknum-body-form" ref="calculatorForm" :model="form" :rules="rules" hide-required-mark label-position="right" :label-width="100">
          <div style="padding-top: 30px;" v-if="type === 'num'">
            <FormItem label="分支行号：" prop="bankLinenumber" key="bankLinenumber">
              <Input type="text" v-model="form.bankLinenumber" placeholder="请输入完整的行号" maxlength="12" v-text-only="{textType: 'num' }"></Input>
            </FormItem>
          </div>

          <div v-else>
            <!-- <FormItem label="所属地区：" key="city">
              <area-cascader v-if="cityShow" type='text' placeholder="请选择所属地区" v-model="city" :data="pcaa" @change="cityChange"></area-cascader>
            </FormItem> -->

            <FormItem label="总行名称：" prop="bankWholename" key="bankWholename">
              <Select v-model="form.bankWholename" filterable :remote-method="remoteMethod1" placeholder="请输入总行关键字" @on-change="handleBankChange">
                <Option v-for="item in bankList" :value="item.value" :key="item.text">{{item.text}}</Option>
              </Select>
            </FormItem>
            <FormItem label="分支行：" prop="keyWord" key="keyWord">
              <Select v-model="form.keyWord" filterable :disabled="branchDisabled" :remote-method="remoteMethod2" placeholder="请输入支行关键字" @on-change="handleBranchChange">
                <Option v-for="item in branchList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </div>
        </Form>
      </div>
      <div class="banknum-footer">
        <template v-if="resultData">
          <p class="banknum-footer-msg" v-if="resultData.msg">{{resultData.msg}}</p>

          <div id="acctContent" class="banknum-footer-content" v-if="resultData.bankNum">
            <div>
              <span>银行全称：</span>
              <span>{{resultData.fullName}}</span>
            </div>
            <div>
              <span>行号：</span>
              <span>{{resultData.bankNum}}</span>
            </div>
          </div>
        </template>

        <span v-if="resultData && resultData.bankNum" id="acctBtn" class="banknum-footer-btnCopy">复制</span>

        <div>
          <Button type="primary" class="w100" :disabled="isDisabled" @click="onSubmit">{{btnName}}</Button>
          <Button type="default" class="w65 ml5" @click="clearForm">重置</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import 'vue-area-linkage/dist/index.css'
import { pcaa } from 'area-data'

export default {
  data () {
    return {
      trialModal: false,

      type: 'bank', // num 行号查询， bank 银行名称查询
      initData: {
        bankLinenumber: '',
        city: '',
        bankWholename: undefined, // 为空时设置undefined，否则placeholder无效
        keyWord: undefined,
      },
      form: {},
      rules: {
        bankLinenumber: { required: true, message: '请输入12位数联行行号', trigger: 'blur' },
        city: { required: true, message: '请选择所属地区', trigger: 'blur' },
        bankWholename: { required: true, message: '请输入总行名称', trigger: 'blur' },
        keyWord: { required: true, message: '请输入支行', trigger: 'blur' }
      },

      // 地址联动
      cityShow: true,
      pcaa: pcaa,
      city: [],

      bankList: [],
      branchList: [],

      resultData: {},
      numResultData: {},
      bankResultData: {},

      btnName: '立即查询', // 最终的按钮展示文字
      numBtnName: '立即查询', // 行号查询 按钮文字
      bankBtnName: '立即查询', // 银行名称查询 按钮文字
    }
  },
  computed: {
    // bankDisabled () {
    //   return !(this.city.length > 0)
    // },
    branchDisabled () {
      // return !(this.form.city && this.form.bankWholename)
      return !(this.form.bankWholename)
    },
    isDisabled () {
      if (this.type === 'num' && this.form.bankLinenumber) {
        return false
      }
      if (this.type === 'bank' && this.form.bankWholename && this.form.keyWord) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.form = this.deepCopy(this.initData)
  },
  destroyed: function () {
    this.myClipboard ? this.myClipboard.destroy() : '';
  },
  methods: {
    show () {
      this.form = this.deepCopy(this.initData)
      this.trialModal = true
    },
    hide () {
      this.trialModal = false
    },

    // 切换选项
    changeType (type) {
      this.type = type
      this.result()
    },
    // 修改地址
    // cityChange () {
    //   if ((this.city[1] === '市辖区' ? this.city[0] : this.city[1]) === this.form.city) return false;
    //   this.form.city = this.city[1] === '市辖区' ? this.city[0] : this.city[1]
    //   this.getBankList()
    // },
    remoteMethod1 (querry) {
      // 避免选中后再次查询
      if (querry !== this.form.bankWholename) {
        this.getBankList(querry)
      }
    },
    remoteMethod2 (querry) {
      this.getBranchList(querry)
      // this.getBranchList(querry)
    },
    // 获取总行列表
    async getBankList (querry) {
      this.sendGet({
        url: '/trade-center/bill-acceptor/page',
        data: { page: 1, row: 10, acceptorName: querry }
      }, res => {
        res = res.data
        this.bankList = this.deepCopy(res.data.content).map(v => ({ value: v.name, text: v.name, item: v }))
        this.branchList = []
        this.form.keyWord = undefined
        console.log(this.bankList);
      }, err => {
        console.log(err);
      })
    },
    handleBankChange (val) {
      console.log(val);
      this.form.bankWholename = val
      this.getBranchList()
    },
    // 获取支行列表
    async getBranchList (querry) {
      this.sendGet({
        url: '/trade-center/bill-acceptor/detail/page',
        data: { page: 1, row: 10, acceptorName: this.form.bankWholename, searchKey: querry || '' }
      }, res => {
        res = res.data
        this.branchList = Object.assign([], this.deepCopy(res.data.content).map(v => ({ value: v.fullName, text: v.fullName, item: v })))

        console.log('this.branchList', this.branchList);
      }, err => {
        console.log(err);
      })
    },
    handleBranchChange (val) {
      this.form.keyWord = val
    },

    // 清空
    clearForm () {
      this.$refs.calculatorForm.resetFields();
      if (this.type === 'num') {
        this.form.bankLinenumber = ''
      } else {
        this.cityShow = false;
        setTimeout(() => {
          this.cityShow = true;
        })
        this.city = []
        this.form.city = ''
        this.form.bankWholename = ''
        this.form.keyWord = ''
      }
      this.resultData = {}
      this[this.type + 'resultData'] = {}
    },
    // 立即查询
    onSubmit () {
      this.$refs.calculatorForm.validate(valid => {
        if (valid) {
          console.log('submit!');
          this.bankSearch()
        } else {
          console.log('error submit!!', valid);
          return false;
        }
      })
    },
    // 查询
    async bankSearch () {
      let data = null;
      if (this.type === 'num') {
        data = {
          searchKey: this.form.bankLinenumber,
        }
      } else {
        data = {
          acceptorName: this.form.bankWholename,
          searchKey: this.form.keyWord,
        }
      }

      this.sendGet({
        url: '/trade-center/bill-acceptor/detail/page',
        data
      }, res => {
        console.log(res);
        res = res.data.data
        this[this.type + 'ResultData'] = res.content.length > 0 ? this.deepCopy(res.content[0]) : { msg: res.message }
        this[this.type + 'BtnName'] = '重新查询'

        this.result()
        this.initBtnCopy();  // 初始化复制
      }, err => {
        console.log(err);
      })
    },
    result () {
      this.resultData = this[this.type + 'ResultData']
      this.btnName = this[this.type + 'BtnName']
    },
    // 初始化复制按钮
    initBtnCopy () {
      this.myClipboard ? this.myClipboard.destroy() : '';
      this.myClipboard = new this.clipboard('#acctBtn', {
        target: function () {
          return document.querySelector('#acctContent')
        }
      });

      this.myClipboard.on('success', (e) => {
        this.$Message.success("复制成功!");
        e.clearSelection();
      });
      this.myClipboard.on('error', (e) => {
        this.$Message.info('请按 Ctrl+C 复制文字');
      });
    }
  }
}
</script>


<style lang="less" scoped>
// 弹框组件
.banknumBg {
  /deep/ .ivu-modal-header {
    padding: 0;
    height: 80px;

    .ivu-modal-header-content {
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      background: url(~@/assets/img/common/icon_hanghaochaxun.png) no-repeat
          25px 15px,
        linear-gradient(90deg, #e12e32 0%, #e5322b 49%, #ff4800 100%);
    }
  }

  /deep/ .ivu-modal-close {
    top: 2px;
    right: 3px;
  }

  /deep/ .ivu-modal-body {
    padding: 0;
  }

  .banknum {
    &-body {
      height: 270px;
      background: #f6f4f5;

      &-tab {
        padding-top: 17px;
        display: flex;
        justify-content: center;
        box-shadow: 0px -1px 12px 0px rgba(0, 0, 0, 0.1) inset;
        overflow: hidden;

        li {
          display: inline-block;
          width: 200px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          position: relative;
          cursor: pointer;
          background: #f6f4f5;
          box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.09);
          z-index: 1;

          svg {
            vertical-align: -5px;
            margin-right: 5px;
          }

          &.active {
            background: #fff;
            color: #e1241a;
            z-index: 3;
          }
        }
      }
      &-form {
        height: 214px;
        background: #fff;
        padding: 30px 80px 0;

        /deep/.area-select.large {
          width: 100%;
          line-height: 15px;
        }
      }
    }
    &-footer {
      height: 80px;
      background: #f6f4f5;
      box-shadow: 0px 12px 11px 0px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0px 20px 0px 50px;

      &-msg {
        flex: 1;
        text-align: left;
        padding-left: 50px;
      }

      &-content {
        flex: 1;
        overflow: hidden;

        > div {
          width: 100%;
          font-size: 14px;
          color: #333;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span:nth-child(1) {
            display: inline-block;
            width: 90px;
            text-align: right;
            margin-right: 3px;
          }
        }
      }

      &-btnCopy {
        cursor: pointer;
        color: #1b89e8;
        border: 1px solid #1b89e8;
        border-radius: 4px;
        padding: 2px 4px;
        font-size: 12px;
        vertical-align: 1px;
        margin-right: 15px;
        margin-left: 15px;

        &:hover {
          background: #1b89e8;
          color: #fff;
        }
      }

      &:last-child {
        white-space: nowrap;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/CommonBankNumSearch.vue